/** 返回当前是否有新版报名页权限
 * @returns {boolean} true: 有新版报名页权限，false: 无新版报名页权限
 */
const isShowNewRegistration = (grayData: any, hostId: string | number) => {
  const { newRegistrationGrayType = '0', registrationRedirectNewUrlHost } = grayData || {};

  if (
    newRegistrationGrayType === '2' ||
    (newRegistrationGrayType === '1' && registrationRedirectNewUrlHost?.indexOf(hostId) > -1)
  )
    return true;
  return false;
};
export default isShowNewRegistration;
